<template>
  <div class="row mt-2">
    <div class="col-4">
      <div class="input-group">
        <span class="input-group-text">Look Back (months)</span>
        <input v-model="monthsAgo" type="number" min="1" max="12" class="form-control text-right" @change="validateMonthsAgo" />
        <span class="input-group-text">Page Size</span>
        <select v-model="pageSize" class="form-control">
          <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
        </select>
        <button class="btn btn-primary btn-sm" @click="getInvoices">Refresh</button>
      </div>
    </div>
    <div class="col">
      <div v-if="isLoadingReport">
        <i class="fa fa-spinner fa-spin"></i>
        <span class="ms-2">loading invoice...</span>
      </div>
    </div>
    <div v-if="isSuperAdmin" class="col-2 text-right">
      <a href="#" @click="viewJson">view JSON data</a>
    </div>
  </div>
  <div class="row p-2 mt-2">
    <div class="col">
      <z-table
        v-model="invoices"
        class="table table-bordered table-striped"
        :is-single-row-detail="false"
        :is-header-fixed="isHeaderFixed"
        :columns="tableColumnsName"
        :loading="isLoading"
        @sort="setOrder"
      >
        <template #tbody="props">
          <td class="custom-column-60">
            <a href="#" @click="viewInvoice(props.row)">view</a>
          </td>
          <td>{{ props.row.date }}</td>
          <td>{{ props.row.number }}</td>
          <td>{{ props.row.period }}</td>
          <td class="text-right">{{ props.row.amount }}</td>
          <td>{{ props.row.status }}</td>
        </template>
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
  </div>
  <DialogViewJson v-model="actionJson" @closing="closeModal" />
  <DialogPreview v-model="actionPreview" @closing="closeModal" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import globals from '@/plugins/globals'
import ZTable from '@/components/utilities/elements/Table.vue'
import DialogViewJson from './DialogViewJson.vue'
import DialogPreview from './DialogPreview.vue'
export default {
  name: 'LocationInvoices',
  components: {
    ZTable,
    DialogViewJson,
    DialogPreview
  },
  data() {
    return {
      isHeaderFixed: true,
      isLoading: false,
      isLoadingReport: false,
      actionJson: null,
      actionPreview: null,
      pageSize: 25,
      pageSizes: [25, 50, 100],
      monthsAgo: 3
    }
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(locationStore, ['loading', 'location', 'stripeInvoices']),
    isSuperAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    tableColumnsName() {
      let columns = [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        { field: 'date', label: 'Date', sortable: false },
        { field: 'number', label: 'Number', sortable: false },
        { field: 'period', label: 'Period', sortable: false },
        { field: 'amount', label: 'Amount $', sortable: false, class: 'text-right' },
        { field: 'status', label: 'Status', sortable: false }
      ]
      return columns
    },
    isStripeCustomer() {
      let _is = false
      if (this.location.customerId) {
        _is = true
      }
      return _is
    },
    invoices() {
      let _invoices = []
      if (this.stripeInvoices) {
        if (this.stripeInvoices.data) {
          this.stripeInvoices.data.forEach((element) => {
            _invoices.push({
              id: element.id,
              date: globals.formatStripeDate(element.created),
              number: element.number,
              amount: (parseFloat(element.amount_due) / 100).toFixed(2),
              amountPaid: (parseFloat(element.amount_paid) / 100).toFixed(2),
              status: element.status,
              urlPDF: element.invoice_pdf,
              period: globals.formatStripeDate(element.period_start) + ' - ' + globals.formatStripeDate(element.period_end)
            })
          })
        }
      }
      console.log('Invoices', _invoices)
      return _invoices
    },
    hasMore() {
      let _is = false
      if (this.stripeInvoices) {
        _is = this.stripeInvoices.has_more
      }
      return _is
    },
    lastInvoiceId() {
      let _id = null
      if (this.stripeInvoices) {
        _id = this.stripeInvoices.data[this.stripeInvoices.data.length - 1].id
      }
      return _id
    },
    gotInvoices() {
      let _is = false
      if (this.stripeInvoices) {
        _is = true
      }
      return _is
    },
    json() {
      let _json = null
      if (this.stripeInvoices) {
        _json = this.stripeInvoices
      }
      return _json
    }
  },
  methods: {
    ...mapActions(locationStore, ['getStripeInvoices', 'getInvoiceReport']),
    init() {
      this.actionJson = null
      this.actionPreview = null
      this.getInvoices()
    },
    viewJson() {
      this.actionJson = this.json
    },
    encodeFileUrl(url) {
      const urlParts = url.split('/') // Split URL by "/"
      const fileName = urlParts.pop() // Extract the last part (file name)
      const encodedFileName = encodeURIComponent(fileName) // Encode the file name
      return urlParts.join('/') + '/' + encodedFileName // Reconstruct the URL
    },
    async viewInvoice(data) {
      if (!this.isLoadingReport) {
        this.actionPreview = null
        this.isLoadingReport = true
        console.log('View Invoice', data)
        let report = await this.getInvoiceReport(globals.toBase64(data.urlPDF))
        if (report) {
          if (report.indexOf('error') > -1) {
            alert('Failed to fetch PDF')
          } else {
            const content = `data:application/pdf;base64,${report}`
            this.actionPreview = {
              title: 'Invoice',
              content: content,
              mimeType: 'application/pdf',
              height: '500px'
            }
          }
        }
        this.isLoadingReport = false
      }
    },
    closeModal() {
      this.actionJson = null
      this.actionPreview = null
    },
    validateMonthsAgo() {
      if (this.monthsAgo > 12) {
        this.monthsAgo = 12
      } else if (this.monthsAgo < 1) {
        this.monthsAgo = 1
      }
    },
    async getInvoices() {
      if (this.isStripeCustomer) {
        this.isLoading = true
        this.validateMonthsAgo()
        let data = {
          id: this.location.customerId,
          pageSize: this.pageSize,
          monthsAgo: this.monthsAgo,
          startingAfter: this.hasMore ? this.lastInvoiceId : null
        }
        console.log('Getting Invoices', data)
        await this.getStripeInvoices(data)
        this.isLoading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
